import { useLocation } from "@swa-ui/browser";

import { getPageId } from "../getPageId";

export const usePageId = () => {
  const { pathname } = useLocation();

  return { pageId: getPageId(pathname) };
};
